var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDynamicTrendUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51803 12.8738C7.51803 11.4873 7.51803 5.43225 7.51803 3.32429C7.51803 3.06964 7.82603 2.94232 8.00803 3.14038L12.39 7.96463C12.586 8.17684 12.922 8.19099 13.132 7.99293C13.342 7.79486 13.356 7.45533 13.16 7.24311L7.37803 0.8768C7.16803 0.650442 6.80403 0.650442 6.60803 0.8768L0.840025 7.24311C0.630025 7.46947 0.672025 7.85145 0.924025 8.03537C1.13402 8.19099 1.44202 8.16269 1.62402 7.96463L6.00603 3.14038C6.17403 2.95646 6.49603 3.06964 6.49603 3.33844V12.9162C6.49603 13.2416 6.79003 13.4963 7.11203 13.4397C7.35003 13.3831 7.51803 13.1426 7.51803 12.8738Z",
    fill: "#C7EAA3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicTrendUp);
export default __webpack_public_path__ + "static/media/dynamic-trend-up.6228064c.svg";
export { ForwardRef as ReactComponent };